import { message } from 'antd';
import defaults from 'lodash/defaults';
import get from 'lodash/get';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { i18n } from '@/settings';

const defaultConfig = { translation: 'alert', prefix: 'error' };

export default (config) => {
  const { translation, prefix } = defaults(config, defaultConfig);
  
  const { t } = useTranslation(translation);
  
  const putErrorCode = useCallback((err) => {
    if (!err) {
      message.error(t('error.INTERNALERROR.0'));
      return;
    }
    const code = get(err, ['response', 'data', 'reference'], '0');
    const name = get(err, ['response', 'data', 'name'], 'INTERNALERROR');
    const errorCodeKey = `${prefix}.${name}.${code}`;
    const exist = i18n.exists(`${translation}:${errorCodeKey}`);
    message.error(exist ? t(errorCodeKey) : t('error.INTERNALERROR.0'));
  }, [prefix, t, translation]);
  
  return {
    putErrorCode
  };
};
